// Sample JSON templates for quick testing

export interface Sample {
  name: string;
  description: string;
  json: string;
}

export const samples: Sample[] = [
  {
    name: 'User Profile',
    description: 'Common user data structure',
    json: `{
  "id": 12345,
  "username": "john_doe",
  "email": "john@example.com",
  "profile": {
    "firstName": "John",
    "lastName": "Doe",
    "age": 28,
    "location": "San Francisco, CA"
  },
  "preferences": {
    "theme": "dark",
    "notifications": true,
    "language": "en-US"
  },
  "tags": ["developer", "designer", "writer"]
}`
  },
  {
    name: 'API Response',
    description: 'Typical REST API response',
    json: `{
  "status": "success",
  "code": 200,
  "data": {
    "items": [
      {
        "id": 1,
        "title": "First Item",
        "completed": false
      },
      {
        "id": 2,
        "title": "Second Item",
        "completed": true
      }
    ],
    "total": 2,
    "page": 1
  },
  "timestamp": "2025-01-15T10:30:00Z"
}`
  },
  {
    name: 'Configuration',
    description: 'App configuration file',
    json: `{
  "app": {
    "name": "MyApp",
    "version": "1.2.3",
    "environment": "production"
  },
  "database": {
    "host": "localhost",
    "port": 5432,
    "name": "myapp_db",
    "ssl": true
  },
  "features": {
    "analytics": true,
    "darkMode": true,
    "betaFeatures": false
  },
  "limits": {
    "maxUsers": 1000,
    "maxFileSize": 10485760,
    "requestsPerMinute": 60
  }
}`
  },
  {
    name: 'E-commerce Product',
    description: 'Product catalog entry',
    json: `{
  "sku": "PROD-001",
  "name": "Wireless Headphones",
  "price": 129.99,
  "currency": "USD",
  "inStock": true,
  "categories": ["Electronics", "Audio", "Headphones"],
  "specifications": {
    "color": "Matte Black",
    "batteryLife": "30 hours",
    "connectivity": "Bluetooth 5.0",
    "weight": "250g"
  },
  "ratings": {
    "average": 4.5,
    "count": 1247
  }
}`
  }
];
